export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Error.vue`
    )
  },
  {
    path: '/',
    meta: {roleId: 0},
    name: 'Root',
    redirect: {
      name: 'Profile'
    }
  },
  {
    path: '/dang-nhap',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Login.vue`
    )
  },
  {
    path: '/dang-ky',
    meta: {
      public: true,
    },
    name: 'Register',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Register.vue`
    )
  },
  {
    path: '/quen-mat-khau',
    meta: {
      public: true,
    },
    name: 'ForgotPassword',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/ForgotPassword.vue`
    )
  },
  {
    path: '/tai-khoan',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 0},
    name: 'Profile',
    component: () => import(
      `@/views/Profile.vue`
    )
  },
  {
    path: '/khach-hang/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 2 },
    name: 'CustomerList',
    component: () => import(
      `@/views/Customer/list.vue`
    )
  },
  {
    path: '/khach-hang/:Pid',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, createButton: true, createButtonText: 'Reset password', createButtonIcon: 'refresh', roleId: 2 },
    name: 'CustomerDetail',
    component: () => import(
      `@/views/Customer/detail.vue`
    )
  },  
  {
    path: '/thanh-toan-don-hang/',
    meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 2 },
    name: 'PayOrderList',
    component: () => import(
      `@/views/PayOrder/list.vue`
    )
  },
  {
    path: '/lich-su-thanh-toan/',
    meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: -1 },
    name: 'PayHistoryList',
    component: () => import(
      `@/views/PaymentHistory/PaymentHistoryList.vue`
    )
  },
  {
    path: '/thong-bao/',
    meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 0 },
    name: 'Notification',
    component: () => import(
      `@/views/Notification/list.vue`
    )
  },
  {
    path: '/tinh-cuoc-phi/',
    meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 0 },
    name: 'Calc',
    component: () => import(
      `@/views/Calc/detail.vue`
    )
  },
  {
    path: '/quan-ly-kien-hang/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, importButton: true, exportButton: true, refreshButton: true, roleId: 0 },
    name: 'StoreManager',
    component: () => import(
      `@/views/StoreManager/list.vue`
    )
  },
  {
    path: '/quan-ly-lo-hang/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, importButton: true, roleId: 0 },
    name: 'BigPackage',
    component: () => import(
      `@/views/BigPackage/list.vue`
    )
  },
  {
    path: '/hang-vo-chu/',
    meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 0 },
    name: 'NoneOwner',
    component: () => import(
      `@/views/NoneOwner/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-can-nang/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1 },
    name: 'FeeWeightList',
    component: () => import(
      `@/views/FeeWeight/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-can-nang/:Pid',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 1 },
    name: 'FeeWeightDetail',
    component: () => import(
      `@/views/FeeWeight/detail.vue`
    )
  },
  {
    path: '/cai-dat/phi-khoi/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1 },
    name: 'FeeVolumeList',
    component: () => import(
      `@/views/FeeVolume/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-khoi/:Pid',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 1 },
    name: 'FeeVolumeDetail',
    component: () => import(
      `@/views/FeeVolume/detail.vue`
    )
  },
  {
    path: '/cai-dat/cau-hinh-chung',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 1},
    name: 'Configuration',
    component: () => import(
      `@/views/Configuration/detail.vue`
    )
  },
  {
    path: '/cai-dat/hang-khach-hang/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1 },
    name: 'LevelList',
    component: () => import(
      `@/views/CustomerLevel/list.vue`
    )
  },
  {
    path: '/cai-dat/hang-khach-hang/:Pid',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 1 },
    name: 'LevelDetail',
    component: () => import(
      `@/views/CustomerLevel/detail.vue`
    )
  },
  {
    path: '/nhan-vien/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1 },
    name: 'StaffList',
    component: () => import(
      `@/views/Staff/list.vue`
    )
  },
  {
    path: '/nhan-vien/:Pid',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 1 },
    name: 'StaffDetail',
    component: () => import(
      `@/views/Staff/detail.vue`
    )
  }
];
